import { Pipe, PipeTransform } from '@angular/core';
import { camelToNormal } from '../../../utils/text-case';

@Pipe({
  name: 'camelToNormal'
})
export class CamelToNormalPipe implements PipeTransform {
  transform(value: string): string {
    return camelToNormal(value);
  }
}